// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"P8-z"};